module["exports"] = ["#", "##", "###", "###a", "###b", "###c"];